export enum ETipoGrupoDRE {
    Receitas = 1,
    Despesas = 2,
    Totalizador = 3,
}
